<div class="mt-0">
	<tsp-treatment-progress-bar [progress]="treatmentProgress()!" (consolidationDays)="updateConsolidationDays($event)"
		(isValid)="isConsolidationValid.set($event)" />
</div>

<div class="mt-5">
	<tsp-notification-threshold [threshold]="threshold()" (thresholdChange)="threshold.set($event)" />
</div>

@if (publishedPlans()?.length) {
<div class="my-5">
	<tsp-published-plans-progress [publishedPlans]="publishedPlans()!" />
</div>
}